<template>
  <div>
    <ul class="flex items-center text-sm">
      <li class="leading-none mr-3 xl:mr-4">
        <router-link to="/">
          {{ tr('common.home') }}
        </router-link>
      </li>
      <li class="leading-none mr-3 xl:mr-4">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 152.51 247.97" v-bind:svg-inline="''" v-bind:class="'h-2 w-2 transform rotate-180'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M124 248l28.35-28.36L56.25 124l96.26-95.57L124 0 0 124l124 124" fill="#05164d"/></svg>
      </li>
      <li class="leading-none">
        <span>{{ title }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import Breadcrumb from '~components/shared/breadcrumb.js'

export default Breadcrumb.extend()
</script>
